import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as bootstrap from 'bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AuditService } from 'src/app/services/audit.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-preview-audit',
  templateUrl: './preview-audit.component.html',
  styleUrls: ['./preview-audit.component.scss']
})
export class PreviewAuditComponent implements OnInit {
  @ViewChild('certificateContainer', { static: false }) certificate!: ElementRef;

  roleid: number = 0;
  iSocietyDetailsTransId: number = 0;
  iSocietyDetailsId: number | null = null;
  isReadOnly: boolean = true;
  Balancedatas: any[] = [];
  hasGovernmentShareCapital = false;
  tempAuditYear: string = '';

  loading = false;
  auditStatus: any = {};
  DepUpload: any = {};
  ARnewUpload: any = {};
  trans: any = {};
  allData: any = {};
  otherParams: any = {};
  auditorUploadedDocument: string = '';
  auditMember: any = {};
  allotData: any = {};
  services: any = {};
  service: any = {};
  column: any[] = [];
  col: any[] = [];
  lstBussinessUpgrades: any[] = [];
  assetData: any = {};
  liabilityData: any = {};
  GovtData: boolean = false;
  asOnDate: string = '';

  hidebutton: boolean = false;
  hideRemark: boolean = false;
  hideARemarks: boolean = false;
  existingDeptRemark: boolean = false;
  existingARRemark: boolean = false;
  download: boolean = false;

  constructor(
    private finalchecklist: FinalChecklistService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private auditService: AuditService,
    private authService: AuthService,
    private config: ConfigService
  ) { }

  ngOnInit(): void {
    this.tempAuditYear = this.getPreviousAuditYear();

    this.roleid = this.authService.currentUserValue.roleId;

    this.route.paramMap.subscribe((params) => {
      const transId = params.get('iSocietyDetailsTransId');
      this.iSocietyDetailsTransId = transId ? +transId : 0;

      const id = params.get('iSocietyDetailsId');
      this.iSocietyDetailsId = id ? +id : null;

      if (this.iSocietyDetailsTransId && this.iSocietyDetailsId) {
        this.GetAllData(this.iSocietyDetailsTransId);
        this.GetServices(this.iSocietyDetailsId);
      } else {
        console.warn('Invalid or missing Society ID');
      }
    });

    this.column = [
      { prop: 'headName', name: 'Head' },
      { prop: 'subHeadName', name: 'Sub-Head' },
      { prop: 'subHeadOther', name: 'Other' },
      { prop: 'amount', name: 'Amount' }
    ];

    this.col = [
      { prop: 'labelName', name: 'Field Name' },
      { prop: 'value', name: 'Value' }
    ];
  }
  getPreviousAuditYear(): string {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    if (currentMonth >= 3) {
      return `${currentYear - 1}-${currentYear}`;
    } else {
      return `${currentYear - 2}-${currentYear - 1}`;
    }
  }
  back() {
    window.history.back();
  }


  GetServices(iSocietyDetailstId: number): void {
    this.finalchecklist.getservicesDatas(iSocietyDetailstId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.lstBussinessUpgrades = response.data;
        }
      },
      error: (error) => {
        console.error("Error fetching services", error);
      }
    });
  }
  
  downloadFile(fileName: string) {
    const fileUrl = this.config.getFileUrl() + 'BalanceSheet/' + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
  sUploadRD: any;
  sUploadpnL: any;
  UploadbalanceList: any;
  GetAllData(iSocietyDetailsTranID: number): void {
    this.finalchecklist.getlistDatas(iSocietyDetailsTranID).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.allData = response.data;
          this.trans = this.allData.societyDetailsTrans;
          const rawBalanceData = this.allData.finalBalanceSheet || [];

          this.asOnDate = rawBalanceData?.[0]?.asOnDate || '';
          this.UploadbalanceList = this.allData?.finalBalanceSheet?.[0]?.sUploadbalanceList || '';
          this.sUploadRD = this.allData?.finalBalanceSheet?.[0]?.sUploadRD || '';

          this.sUploadpnL = this.allData?.finalBalanceSheet?.[0]?.sUploadpnL || '';
          this.auditorUploadedDocument = this.trans?.auditorUploadedDocument || '';
          this.auditStatus = { sRemark: this.trans?.auditorRemark || '' };
          this.DepUpload = {
            DepartmentalRemarkDocument: this.trans?.verifierDocument || '',
            sDepartmentalRemark: this.trans?.verifierRemark || '',
            DepartmentalRemarkFileName: this.trans?.DepartmentalRemarkFileName || '',
            documentExtension: this.trans?.documentExtension || '',
            transid: this.trans?.iSocietyDetailsTranID || 0
          };
          this.ARnewUpload = {
            DepartmentalRemarkDocument: this.trans?.arDocument || '',
            sDepartmentalRemark: this.trans?.arRemark || '',
            DepartmentalRemarkFileName: this.trans?.DepartmentalRemarkFileName || '',
            documentExtension: this.trans?.documentExtension || '',
            transid: this.trans?.iSocietyDetailsTranID || 0
          };

          this.evaluateRoleLogic();

          this.otherParams = this.allData.finalOtherParameters;
          this.auditMember = this.allData.auditMemberDetails;
          this.allotData = this.allData.auditAllotmentDetails;
          this.services = this.allData?.societyServiceDetails;
          this.service = this.services?.[0];

          const fields: any[] = this.allData?.societyServiceDetailFields || [];

          const checkIds = [...new Set(fields.filter(f => f?.checkd).map(f => f.societyCheckID))];
          checkIds.forEach(id => this.Getfields(id));

          setTimeout(() => this.mapFieldsToServices(fields), 1000);



          this.Balancedatas = rawBalanceData.map((item: any) => ({
            headName: item.headName,
            subHeadName: item.subHeadName,
            subHeadOther: item.subHeadOther || '',
            amount: item.amount || 0,
            type: item.type || 0,
          }));
          this.assetData = this.Balancedatas.filter((item: any) => item.type === 2);
          this.liabilityData = this.Balancedatas.filter(
            (item: any) => item.type === 1
          );

          this.hasGovernmentShareCapital = this.Balancedatas.some(
            item => item.subHeadName === 'Government Share Capital'
          );
          this.GovtData = this.hasGovernmentShareCapital;
        } else {
          this.toastService.showError('Failed to fetch data');
        }
      },
      error: (error) => {
        console.error('Error fetching data', error);
        this.toastService.showError('Error occurred while fetching data');
      }
    });
  }

  calculateTotal(data: any[]): number {
    return data.reduce((sum, item) => sum + (parseInt(item.amount) || 0), 0);
  }

  get totalLiability(): number {
    return this.calculateTotal(this.liabilityData);
  }

  get totalAsset(): number {
    return this.calculateTotal(this.assetData);
  }

  formatDateToYYYYMMDD(dateStr: string | null | undefined): string {
    if (
      !dateStr ||
      dateStr.startsWith('0001-01-01') ||
      dateStr.startsWith('1900-01-01')
    ) {
      return '';
    }

    const date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      return '';
    }

    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  evaluateRoleLogic(): void {
    const t = this.trans;
    if (this.roleid == 13) {
      if (t.moveForwardToAR && !t.iVerifierRemark && !t.iVerifierMoveForward && !t.iARRemark) {
        this.hidebutton = true; this.hideRemark = true; this.existingDeptRemark = true;
      } else if (t.moveForwardToAR && t.iVerifierRemark && t.iVerifierMoveForward && !t.iARRemark) {
        this.hidebutton = true; this.hideARemarks = false; this.hideRemark = false; this.existingDeptRemark = false;
      } else if (t.moveForwardToAR && t.iVerifierRemark && t.iVerifierMoveForward && t.iARRemark && !t.iARMoveForward) {
        this.hidebutton = false; this.hideARemarks = false; this.hideRemark = false; this.existingDeptRemark = false;
      } else if (t.moveForwardToAR && t.iVerifierRemark && t.iVerifierMoveForward && t.iARRemark && t.iARMoveForward) {
        this.hidebutton = true; this.hideARemarks = false; this.hideRemark = false; this.existingDeptRemark = false; this.download = true; this.existingARRemark = true;
      }
    } else {
      if (t.moveForwardToAR && !t.iVerifierRemark && !t.iVerifierMoveForward) {
        this.hidebutton = true; this.hideRemark = false; this.existingDeptRemark = true;
      } else if (t.moveForwardToAR && t.iVerifierRemark && !t.iVerifierMoveForward) {
        this.hidebutton = false; this.hideRemark = true; this.existingDeptRemark = true;
      } else if (t.moveForwardToAR && t.iVerifierRemark && t.iVerifierMoveForward) {
        this.hidebutton = true; this.hideRemark = true;
      }
    }
  }

  mapFieldsToServices(fields: any[]): void {
    this.lstBussinessUpgrades.forEach(upgrade => {
      const relatedFields = fields.filter(f => f.societyCheckID === upgrade.id);
      if (!relatedFields.length) return;

      upgrade.checkd = true;

      relatedFields.forEach(field => {
        upgrade.lstServiceData?.forEach((sub: any) => {
          if (sub.fieldID === field.fieldID && (sub.value == null || sub.value === '')) {
            sub.value = field.value;
          }
        });

        upgrade.subFields?.forEach((sub: any) => {
          if (sub.subFieldID === field.subFieldID) {
            sub.value = field.value;
          }
        });

        upgrade.groupedSubFields?.forEach((group: any) => {
          if (!group.heading && field.groupHeading) group.heading = field.groupHeading;

          if (group.fieldID === field.fieldID) {
            const inputType = group.inputType?.toLowerCase();
            if (inputType === 'dropdown') {
              group.value = this.parseDropdownValue(inputType, field.value);
            } else if (inputType === 'boolean') {
              const isGroupTrue = group.value === true || group.value === 'true';
              if (isGroupTrue && Array.isArray(group.groupedConditionalFields)) {
                group.groupedConditionalFields.forEach((subGroup: any) => {
                  subGroup.fields?.forEach((condField: any) => {
                    const matched = relatedFields.find(f => String(f.subFieldID) === String(condField.subFieldID));
                    if (matched?.hasOwnProperty('value')) {
                      condField.value = matched.value;
                    }
                  });
                });
              }
            } else {
              group.value = field.value;
            }
          }

          group.groupedFields?.forEach((subGroup: any) =>
            subGroup.fields?.forEach((gfield: any) => {
              if (gfield.fieldID === field.fieldID) gfield.value = field.value;
            })
          );

          group.conditionalFields?.forEach((condField: any) => {
            if (condField.fieldID === field.fieldID) condField.value = field.value;
          });
        });
      });
    });
  }

  parseDropdownValue(inputType: string, value: any): any {
    if (inputType === 'dropdown' && value != null) {
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          return value.split(',').map(v => v.trim()).filter(Boolean);
        }
      }
      return [value];
    }
    return value;
  }

  Getfields(societyCheckID: number) {
    this.finalchecklist.getfieldsDatas(societyCheckID).subscribe({
      next: (response) => {
        if (response.status !== 200) return;
        const selectedService = this.lstBussinessUpgrades.find(ser => ser.id === societyCheckID);
        if (!selectedService) return;

        selectedService.lstServiceData = response.data;
        this.finalchecklist.getsubfieldsDatas(societyCheckID).subscribe({
          next: (subResponse) => {
            selectedService.subFields = subResponse.data;

            const grouped = selectedService.lstServiceData.map((main: any) => {
              if (!main?.inputType) {
                return {
                  heading: main.labelName,
                  fieldID: main.fieldID,
                  value: main?.value || '',
                  fields: selectedService.subFields.filter((sub: any) => sub.fieldID === main.fieldID)
                };
              } else if (main.inputType === 'dropdown') {
                const options = selectedService.subFields
                  .filter((sub: any) => sub.fieldID === main.fieldID)
                  .map((f: any) => f.labelName || '');
                return {
                  heading: main.labelName,
                  fieldID: main.fieldID,
                  options,
                  inputType: main.inputType
                };
              } else if (main.inputType === 'boolean') {
                const booleanFields = selectedService.subFields.filter((sub: any) => sub.fieldID === main.fieldID);
                const groupedConditionalFields = booleanFields.reduce((acc: any[], field: any) => {
                  const heading = field.headingName || 'General';
                  let group = acc.find(g => g.heading === heading);
                  if (!group) {
                    group = { heading, fields: [] };
                    acc.push(group);
                  }
                  group.fields.push({
                    labelName: field.labelName,
                    headingName: field.headingName,
                    headingFlag: field.headingFlag,
                    inputType: 'number',
                    value: field.value || '',
                    isRequired: field.isRequired || false,
                    fieldID: field.fieldID ?? 0,
                    subFieldID: field.subFieldID ?? 0,
                  });
                  return acc;
                }, []);
                return {
                  heading: main.labelName,
                  fieldID: main.fieldID,
                  inputType: 'boolean',
                  value: true,
                  fields: [],
                  groupedConditionalFields
                };
              } else {
                return main;
              }
            });

            selectedService.groupedSubFields = grouped;
          },
          error: (err) => console.error('Error fetching sub-fields:', err)
        });
      },
      error: (error) => console.error('Error fetching fields:', error)
    });
  }

  // downloadCertificate() {

  //   html2canvas(this.certificate.nativeElement).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('portrait', 'pt', 'a4');
  //     pdf.addImage(imgData, 'PNG', 20, 20, 550, 750);
  //     pdf.save('Checklist.pdf');
  //   });
  //   this.hideModal('previewModel')
  // }
  getTableHeight(rowsLength: number): number {
    const rowHeight = 35;
    const headerHeight = 50;
    return headerHeight + rowsLength * rowHeight;
  }

async downloadCertificate() {

  const cards = Array.from<HTMLElement>(
    this.certificate.nativeElement.querySelectorAll('.certificate-card')
  ).slice(0, 7);

  if (!cards.length) return;

  const pdf = new jsPDF('p', 'pt', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const topMargin = 10;
  const bottomMargin = 12;
  const usablePageHeight = pageHeight - topMargin - bottomMargin;

  let isFirstPage = true;

  for (const card of cards) {
    const originalCanvas = await html2canvas(card, { scale: 2 });
    const canvasWidth = originalCanvas.width;
    const canvasHeight = originalCanvas.height;

    const imgWidth = pageWidth;
    const imgHeight = (canvasHeight * imgWidth) / canvasWidth;

    let renderedHeight = 0;

    while (renderedHeight < canvasHeight) {
      const sliceHeight = Math.min(
        canvasHeight - renderedHeight,
        (usablePageHeight * canvasHeight) / imgHeight
      );

      const sliceCanvas = document.createElement('canvas');
      sliceCanvas.width = canvasWidth;
      sliceCanvas.height = sliceHeight;

      const sliceCtx = sliceCanvas.getContext('2d')!;
      sliceCtx.drawImage(
        originalCanvas,
        0,
        renderedHeight,
        canvasWidth,
        sliceHeight,
        0,
        0,
        canvasWidth,
        sliceHeight
      );

      const sliceData = sliceCanvas.toDataURL('image/png');
      const sliceRenderedHeight = (sliceHeight * imgWidth) / canvasWidth;

      if (!isFirstPage) {
        pdf.addPage();
      }

      pdf.addImage(sliceData, 'PNG', 0, topMargin, imgWidth, sliceRenderedHeight);

      renderedHeight += sliceHeight;
      isFirstPage = false;
    }
  }

  pdf.save('Checklist.pdf');

  this.hideModal('certificateContainer');
}

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      modalInstance.hide();
    }
  }
}
